import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AppSettingsEffects } from './app-settings.effects';
import { categoryAppSettingsReducer } from './app-settings.reducer';

export const provideCategoryAppSettingsStore = () => [
  provideState('category-application-settings', categoryAppSettingsReducer),
  provideEffects([AppSettingsEffects]),
];
